import React from "react";

type DashboardTabsProps = {
  data: { label: string; value: string }[];
  selectedItem: { label: string; value: string };
  setSelectedItem: (item: { label: string; value: string }) => void;
};

export const DashboardTabs: React.FC<DashboardTabsProps> = ({
  data,
  selectedItem,
  setSelectedItem,
}) => {
  return (
    <div className="flex flex-row gap-2 items-center">
      {data.map((item) => (
        <div
          className={`
                      border-2 py-1 px-4 text-[17px] rounded-[20px] cursor-pointer select-none font-medium
                      ${
                        item.value === selectedItem.value
                          ? "text-blue-medium border-blue-medium"
                          : "text-[#00000080] border-[#00000080] "
                      }
                    `}
          onClick={() => setSelectedItem(item)}
          key={item.value}
        >
          {item.label}
        </div>
      ))}
    </div>
  );
};
